<template>
<widget title="Service List Settings" icon="fa-wrench">
	<field label="Display Columns on Service List"
		col-class="col-md-4"
		:params="{type:'checklist',options:fieldOptions}"
		v-model="displayFields"
		v-on:change="saveChanges">
	</field>
	<!--
		
		<field label="Personnel Role Column"
			col-class="col-md-4"
			:params="{type:'boolean'}"
			v-model="personnelRoleColumnActive"
			v-on:change="saveChanges">
		</field>

		<field v-if="personnelRoleColumnActive"
			label="Personnel Role to Display"
			col-class="col-md-4"
			:params="{type:'select',options: personnelRolesOptions}"
			v-model="personnelRolesDisplay"
			v-on:change="saveChanges">
		</field>
	-->
</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Field from "@/components/Field"

export default {
	name: "ServiceListSettingsWidget",
	components: {
		Widget,
		Field
	},
	props: [],
	data(){
		return {
			displayFields: [],
			fieldOptions: [
				{text: 'Emergency Flag',value: 'emergencyIcon'},
				{text: 'Service #',value: 'job_num'},
				{text: 'Service Name',value: 'job_name'},
				{text: 'Customer',value: 'customerCompanyName'},
				{text: 'Site Address',value: 'siteAddress'},
				{text: 'Est. Time (hrs)',value: 'estimated_time'},
				{text: 'Crew Members',value: 'techList'},
				{text: 'Scheduled',value: 'scheduledFor'},
				{text: 'Apt. Time',value: 'aptTime'},
				{text: 'Status',value: 'displayStatus'},
				{text: 'Permit Notification Number',value: 'permit_notification_number'},
				{text: 'Is Warranty Work',value: 'is_warranty_work'},
				{text: 'Pays Mileage',value: 'pays_mileage'},
				{text: 'Pays Per Diem',value: 'pays_perdiem'}
			],
			personnelRoleColumnActive: false,
			personnelRolesDisplay: null
		} 
	},
	watch: {
		'$store.company'() {
			this.initSettings()
		},
		'$store.jobPersonnelRoles'() {
			this.initSettings()
		}
	},
	computed: {
		personnelRolesOptions() {
			return this.optionify(this.$store.jobPersonnelRoles,"title")
		}
	},
	methods: {
		initSettings() {
			this.displayFields = []

			if (this.$store.company.CompanySetting) {

				if (this.$store.company.CompanySetting.custom_service_list_fields_json === 'true' || this.$store.company.CompanySetting.custom_service_list_fields_json == 'false') {
					this.displayFields = ['emergencyIcon','job_num','customerCompanyName','siteAddress','estimated_time','techList','scheduledFor','aptTime','siteAddress','displayStatus']
				}
				else {
					try {
						this.displayFields = JSON.parse(this.$store.company.CompanySetting.custom_service_list_fields_json)

						
					}
					catch (e) {
						this.displayFields = ['emergencyIcon','job_num','customerCompanyName','siteAddress','estimated_time','techList','scheduledFor','aptTime','siteAddress','displayStatus']
					}
				}

				if (this.$store.company.CompanySetting.service_list_role_column > 0) {
					this.personnelRoleColumnActive = true
					this.personnelRolesDisplay = this.$store.company.CompanySetting.service_list_role_column
				}
			}
		},
		saveChanges(value) {
			let vm = this

			this.$nextTick(() => {

				let payload = {
					custom_service_list_fields_json: JSON.stringify(value)
				}

				if (vm.personnelRoleColumnActive)
					payload.service_list_role_column = vm.personnelRolesDisplay
				else
					payload.service_list_role_column = 0

				vm.postData("CompanySetting/save",payload,true).then(response => {
					if (response.success) {
						vm.alertSaved("Selections saved")

						//update company settings
						vm.$store.company.CompanySetting.custom_service_list_fields_json = payload.custom_service_list_fields_json
					}
				})
			})
		}
	},
	created() {
		this.initSettings()

		if (this.$store.jobPersonnelRoles.length == 0)
			this.fetchJobPersonnelRoles()
	}
}
</script>